// 将军令安全验证
<template>
<div>
<div class="g-bd">
  <div class="m-tlt">登录前请先验证将军令动态密码</div>
  <Form class="m-form">
    <form-item class='m-ipt ipt-h' ref="optValidate">
    <urs-input ref="optInput" placeholder="请输入动态密码" :validate="validateOpt" ></urs-input>
    </form-item>
    <div class="m-btns g-pd">
      <urs-button enableTip="确定" @click="onSubmit" ref="submitBtn"></urs-button>
    </div>
  </Form>
</div>
<div class="g-ft g-pd clearfix c-main">
  <a class="f-right" href="https://gj.reg.163.com/faq/p2.html?ct=04">将军令无法使用？</a>
</div>
</div>
</template>

<script>
import reqProxy from '../util/request'
import util from '../util/util'
import code from '../util/codemapper'

let vfoptCode = {
  '412':"将军令验证错误次数过多，请改天再试",
  '430':"此次登录不需要进行密保验证",
  '431':"请求错误，请您稍后再试",
  '480':"动态密码错误，请重试",
  '481':"尝试次数过多，请稍候再试",
  '484':"账号未绑定将军令"
}

util.merge(vfoptCode, code);

const regopt = /^\d{6}$/;

export default {
  props: {
    options:Object
  },
  data () {
    let _this=this;
    return {
      validateOpt(){
        let val = this.currentValue;
        if(!regopt.test(val)){
          _this.$refs.optValidate.setMsg('动态密码格式错误')
          return false
        }
        return true
      }
    }
  },
  mounted () {
    window.Loading.loading = false;
  },
  methods: {
    onSubmit(){
      // 表单校验
      if(this.$refs.optInput.validate()){
        this.$refs.submitBtn.state = 'loading';
        // 提交将军令验证
        let data = {
          un: this.options.un,
          otppwd: this.$refs.optInput.currentValue
        }
        reqProxy({
          url: '/vfotp',
          method: 'POST',
          contentType: 'application/x-www-form-urlencoded',
          data: data,
          success: (data)=>{
            // 校验成功
            // 回到登录且自动帮助用户登录
            this.$refs.submitBtn.state = 'enable'
            this.$emit('changeToLogin',{autoLogin:1})
          },
          error:(data)=>{
            this.$refs.submitBtn.state = 'enable'
            // 校验错误，服务器错误
            // 停留在当前界面，toast提示
            if(data.ret === '480' || data.ret === '500' || data.ret === '501'){
              window.showError(vfoptCode[data.ret]);
              return;
            }
            if(data.ret === '401' && data.dt === '10'){
              data.ret='40110'
            }
            // 其他错误，均返回登录界面
            this.$emit('changeToLogin', {errMsg:vfoptCode[data.ret],ret:data.ret,un:this.options.un})
          }
        });
      }
    }
  }
}
</script>





// WEBPACK FOOTER //
// Verifyopt.vue?397b1ade